var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1887 8.37891C13.2887 8.37891 14.1887 7.47891 14.1887 6.37891C14.1887 5.27891 13.2887 4.37891 12.1887 4.37891C11.0887 4.37891 10.1887 5.27891 10.1887 6.37891C10.1887 7.47891 11.0887 8.37891 12.1887 8.37891ZM12.1887 10.3789C11.0887 10.3789 10.1887 11.2789 10.1887 12.3789C10.1887 13.4789 11.0887 14.3789 12.1887 14.3789C13.2887 14.3789 14.1887 13.4789 14.1887 12.3789C14.1887 11.2789 13.2887 10.3789 12.1887 10.3789ZM12.1887 16.3789C11.0887 16.3789 10.1887 17.2789 10.1887 18.3789C10.1887 19.4789 11.0887 20.3789 12.1887 20.3789C13.2887 20.3789 14.1887 19.4789 14.1887 18.3789C14.1887 17.2789 13.2887 16.3789 12.1887 16.3789Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.23d0883f.svg";
export { ForwardRef as ReactComponent };